var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('i',{staticClass:"ui-icon",class:( _obj = {}, _obj[_vm.icon] = true, _obj.disabled = _vm.disabled, _obj ),style:(_vm.styles),attrs:{"disabled":_vm.stateDisabled},on:{"click":function($event){!_vm.stateDisabled && _vm.$emit('click', $event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }